import Swiper from '../vendors/swiper.min.js';

export default class Sliders {
  static pickupSlider() {
    return new Swiper('.pickup__wrap', {
      loop: true,
      speed: 700,
      autoplay: {
        delay: 4000,
      },
      slidesPerView: 6,
      centeredSlides: true,
      navigation: {
        nextEl: '.pickup__right',
        prevEl: '.pickup__left'
      },
      breakpoints: {
        1200: {
          slidesPerView: 5,
        },
        992: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 1.5,
        }
      }
    });
  }

  static appealSlider() {
    const sliders = [
      {
        selector: '.appeal-slider1',
        pagination: '.swiper-pagination1'
      },
      {
        selector: '.appeal-slider2',
        pagination: '.swiper-pagination2'
      },
      {
        selector: '.appeal-slider3',
        pagination: '.swiper-pagination3'
      },
    ];

    sliders.forEach(s => {
      new Swiper(s.selector, {
        loop: true,
        slidesPerView: 1,
        speed: 500,
        pagination: {
          el: s.pagination
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
      });
    });
  }

  static shopimgSlider() {
    return new Swiper('.shopimg__slider', {
      loop: true,
      speed: 700,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
    });
  }
};
